<template>
	<div>
		<div class="d-flex flex-row mb-4">
			<h1> Información de llamada </h1>
		</div>

		<div class="content-block d-flex flex-row-reverse">
			<b-btn @click="goToCalls" class="cursor-pointer" variant="primary" sice="lg">Ver todas las llamadas</b-btn>
		</div>

		<div class="content-block">
			<table class="table table-sm">
				<tbody>
					<tr>
						<td>Id</td>
						<td>{{call.id}}</td>
					</tr>
					<tr>
						<td>Fecha</td>
						<td>{{getHumanDate(call.createdAt)}}</td>
					</tr>
					<tr>
						<td>Hora</td>
						<td>{{getHumanTime(call.createdAt)}}</td>
					</tr>
					<tr>
						<td>Duración</td>
						<td>{{getHumanTimeBySeconds(call.callDurationSeconds)}}</td>
					</tr>
					<tr>
						<td>Colegio</td>
						<td>{{call.school.name}}</td>
					</tr>
					<tr>
						<td>Tipo de cliente</td>
						<td>{{call.callerType.name}}</td>
					</tr>
					<tr v-if="call.callerName">
						<td>Nombre de cliente</td>
						<td>{{call.callerName}}</td>
					</tr>
					<tr v-if="call.callerPhone">
						<td>Teléfono de contacto</td>
						<td>{{call.callerPhone}}</td>
					</tr>
					<tr v-if="call.callerEmail">
						<td>Correo electrónico de contacto</td>
						<td>{{call.callerEmail}}</td>
					</tr>
					<tr>
						<td>Tema</td>
						<td>{{call.reason.name}}</td>
					</tr>
					<tr>
						<td>Agente</td>
						<td>{{call.user.username}}</td>
					</tr>
				</tbody>
			</table>
		</div>

		<div class="content-block">
			<h3> Comentarios </h3>
			<br>
			<b-card>
				{{call.comments ? call.comments : 'Sin comentarios.'}}
			</b-card>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		call () {
			return this.$store.state.calls.call;
		}
	},
	methods: {
		getHumanTimeBySeconds (time) {
			let hours = Math.floor(time / 3600);
			let minutes = Math.floor((time % 3600) / 60);
			let seconds = time % 60;
			let hoursText = `${hours}h`;
			let minutesText = `${minutes}m`;
			let secondsText = `${seconds}s`;
			if (minutes == 0) return `${secondsText}`;
			if (hours == 0) return `${minutesText} ${secondsText}`;
			return `${hoursText} ${minutesText} ${secondsText}`;
		},
		getHumanTime (date) {
			if (typeof date === 'string' || typeof date === 'number') date = new Date(date);
			let day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
			let month = (date.getMonth() + 1) < 10 ? `0${(date.getMonth() + 1)}` : (date.getMonth() + 1);
			let hours = date.getHours() < 10 ? `0${date.getHours()}` : date.getHours();
			let minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
			let seconds = date.getSeconds() < 10 ? `0${date.getSeconds()}` : date.getSeconds();
			return hours + ':' + minutes;
		},
		getHumanDate (date) {
			if (typeof date === 'string' || typeof date === 'number') date = new Date(date);
			let day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
			let month = (date.getMonth() + 1) < 10 ? `0${(date.getMonth() + 1)}` : (date.getMonth() + 1);
			return day + '/' + month + '/' + date.getFullYear();
		},
		goToCalls () {
			this.$router.push('/calls/');
		}
	}
};
</script>

<style media="screen">

</style>



// WEBPACK FOOTER //
// src/components/calls/Call.vue